<span class="dclose-button" (click)="onClosebtn()">
  <mat-icon>close</mat-icon>
</span>
<h1 *ngIf="data.title && !data.showImageFailure" mat-dialog-title class="dialog-title" [innerHTML]="data.title"></h1>

<div *ngIf="data.showImageFailure" class="image-container">
  <h1 mat-dialog-title class="dialog-title">
    <img src="../../../../../assets/warning_red.svg" class="warning-red" alt="warning">
    {{ 'toastrMsgs.smthingwntWrng' | translate }}

  </h1>
  <h1 mat-dialog-title class="dialog-title sub-text">{{ 'toastrMsgs.plzReloadAndTryAgain' | translate }}</h1>
</div>

<div mat-dialog-content class="dialog-msg">
  <p class="dialog-msg-text" [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions class="button-container">
  <button mat-button *ngIf="data.showNoBtn" [ngClass]="{ 'button no-button-danger': (data.title.indexOf('Roof') >-1 
    || data.title.indexOf('map') >-1 || data?.isMapUpdate), 'button no-button':  (data.title.indexOf('Roof') <= -1 
    || data.title.indexOf('map') <= -1) }" (click)="onNoClick()">{{'buttons.no' | translate }}</button>
  <button mat-button *ngIf="data.showYesBtn" [ngClass]="{ 'button yes-button-danger': (data.title.indexOf('Roof') >-1 
    || data.title.indexOf('map') >-1 || data?.isMapUpdate), 'button yes-button': (data.title.indexOf('Roof') <= -1 
    || data.title.indexOf('map') <= -1) }" (click)="onYesClick()">
    {{ data.showImageFailure ? ('buttons.ok' | translate) : ('buttons.yes' | translate) }}
  </button>
</div>